// @material-ui/core
import {
  FormControlLabel,
  Grid,
  Input,
  Select,
  Switch,
  TextField,
  Typography
} from "@material-ui/core";
import moment from "moment";
import React, { Component } from "react";
import update from "react-addons-update";
import { withRouter } from "react-router";
import { compose } from "redux";
import MainButton from "../../library/button/MainButton";
import LicenseCard from "../../library/card/LicenseCard";
import FullDialog from "../../library/dialog/FullDialog";
import { withView } from "../../library/pages";
import Caba from "../../services/Caba";

class CustomerView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      licenses: [],
      isOpen: false,
      apps: [],
      customer: {
        id: 0
      },
      newLicense: {
        customer: "",
        app: "",
        start: moment().format("YYYY-MM-DDTHH:ss"),
        end: moment()
          .add(1, "year")
          .format("YYYY-MM-DDTHH:ss"),
        isTrial: false,
        numLicenses: 1,
        autoprovisioning: true
      }
    };

    props.toggleLoading(true);
    // make a call
    this.init();
  }

  init = () => {
    Caba.get("/api/v1/customers/" + this.props.match.params.id).then(
      response => {
        const customer = response.data;
        this.props.toggleLoading(false);
        this.setState(prevState => ({
          customer: response.data,
          newLicense: { ...prevState.newLicense, customer: customer.id },
          domains: customer.domainList
        }));

        Caba.get("/api/v1/licenses").then(response => {
          let licenses = response.data.filter(license => {
            return license.customer === this.state.customer.id;
          });

          licenses.map(license => {
            license.customerName = customer.name;

            return this.setState(prevState => {
              let licenses = update(prevState.licenses, { $push: [license] });
              licenses = licenses.sort(
                (a, b) => (b.customer > a.customer ? -1 : 1)
              );
              return { licenses };
            });
          });
        });
      }
    );

    Caba.get(
      `/api/v1/customers/${this.props.match.params.id}/apps/installable`
    ).then(response => {
      this.setState(prevState => ({
        apps: response.data,
        newLicense: {
          ...prevState.newLicense,
          app: response.data.length > 0 ? response.data[0].id : []
        }
      }));
    });
  };

  reset = () => {
    this.setState({
      licenses: [],
      isOpen: false,
      apps: [],
      customer: {
        id: 0
      },
      newLicense: {
        customer: "",
        app: "",
        start: moment().format("YYYY-MM-DDTHH:ss"),
        end: moment()
          .add(1, "year")
          .format("YYYY-MM-DDTHH:ss"),
        isTrial: false,
        numLicenses: 1,
        autoprovisioning: true
      }
    });
  };

  handleAdd = () => {
    this.toggleOpen(true);
  };

  toggleOpen = isOpen => {
    this.setState({ isOpen });
  };

  handleAction = () => {
    this.toggleOpen(false);
    console.info("new license", this.state.newLicense);

    Caba.post("/api/v1/licenses", {
      ...this.state.newLicense,
      start: moment(this.state.newLicense.start).toISOString(),
      end: moment(this.state.newLicense.end).toISOString()
    }).then(response => {
      if (response.status === 200) {
        this.props.notify("success", "200", "Saved");
        // this.props.history.push(
        //   "/customers/" + this.props.match.params.id + "/view"
        // );
        this.reset();
        this.init();
      }
    });
  };

  handleSwitchChange = name => (event, checked) => {
    this.setState(prevState => ({
      newLicense: {
        ...prevState.newLicense,
        [name]: checked
      }
    }));
  };

  handleChangeApp = event => {
    event.persist();
    this.setState(prevState => ({
      newLicense: {
        ...prevState.newLicense,
        app: event.target.value
      }
    }));
  };

  handleChange = name => event => {
    // https://reactjs.org/docs/events.html#event-pooling
    event.persist();
    if (name === "numLicenses") {
      this.setState(prevState => ({
        newLicense: {
          ...prevState.newLicense,
          [name]: parseInt(event.target.value, 10)
        }
      }));
    } else {
      this.setState(prevState => ({
        newLicense: { ...prevState.newLicense, [name]: event.target.value }
      }));
    }
  };

  render() {
    const { licenses, newLicense, customer } = this.state;
    const currentApp = this.state.apps.find(app => {
      return app.id === newLicense.app;
    });

    let hasTrial = false;
    if (currentApp && currentApp.trialDuration !== 0) {
      hasTrial = true;
    }

    return (
      <Grid container spacing={8}>
        {!this.props.loading &&
          this.state.newLicense.app.length > 0 && (
            <Grid item xs={12}>
              <MainButton
                raised
                fullWidth
                colored="blue"
                onClick={this.handleAdd}>
                Add App
              </MainButton>
            </Grid>
          )}

        {licenses.length > 0 &&
          licenses.map((license, index) => {
            return (
              <Grid item xs={12} key={index}>
                <LicenseCard
                  object={license}
                  key={license.id}
                  isExpandable
                  slug="licenses"
                  id={license.id}
                  title={`${license.appName}`}
                />
              </Grid>
            );
          })}

        <FullDialog
          subtitle="New license"
          open={this.state.isOpen}
          onClose={() => this.toggleOpen(false)}
          onAction={this.handleAction}
          button="Add"
          color="blue">
          <Grid container>
            <Grid item xs={12}>
              <TextField
                id="customer"
                label="Customer"
                value={
                  customer.name
                    ? customer.name
                    : newLicense.customer ? newLicense.customer : ""
                }
                margin="normal"
                fullWidth
                onChange={this.handleChange("customer")}
                disabled
              />

              <Typography type="subheading">
                <small>App</small>
              </Typography>

              <Select
                native
                value={newLicense.app}
                onChange={this.handleChangeApp}
                input={<Input id="select-apps" />}
                fullWidth>
                {this.state.apps.map((app, index) => {
                  return (
                    <option value={app.id} key={index}>
                      {app.name}
                    </option>
                  );
                })}
              </Select>

              <TextField
                id="start"
                label="Start"
                value={newLicense.start ? newLicense.start : ""}
                onChange={this.handleChange("start")}
                type="datetime-local"
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                fullWidth
              />

              <TextField
                id="end"
                label="End"
                value={newLicense.end ? newLicense.end : ""}
                onChange={this.handleChange("end")}
                type="datetime-local"
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                fullWidth
              />

              <TextField
                id="numLicenses"
                type="number"
                label="Number of licenses"
                value={newLicense.numLicenses ? newLicense.numLicenses : ""}
                onChange={this.handleChange("numLicenses")}
                margin="normal"
                fullWidth
              />

              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.newLicense.autoprovisioning}
                    onChange={this.handleSwitchChange("autoprovisioning")}
                  />
                }
                label="Auto Provisioning"
              />

              {hasTrial && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.newLicense.isTrial}
                      onChange={this.handleSwitchChange("isTrial")}
                    />
                  }
                  label="Trial"
                />
              )}
            </Grid>
          </Grid>
        </FullDialog>
      </Grid>
    );
  }
}

export default compose(withRouter, withView)(CustomerView);



// WEBPACK FOOTER //
// ./src/pages/customers/CustomerView.js